<div [ngClass] = "{'pc-contained' : isCalledByRightDrawerOrOneTimeAddFlow}" class="pc p-3 position-relative" id="{{'pg' + product.id + 'container'}}">
<a *ngIf="configObj?.programType !== '1P_SNS' && configObj?.appName !== '1P_OA'" class="w-100 h-100 position-absolute pc__tap-zone product-fname" [ngClass]="{'pc__tap-zone--qsc' : calledBy === 'buyItAgainQsc'}" (click)=" sendAdIdClickEvent(); onProductClicked(); setPfmDetailProduct()" [attr.href]="productDetailPath" 
attr.aria-label="{{ (product?.fullName?.length) ? product.fullName : product.name }},price approximatly {{ validPrice | currency: 'USD' }} {{isLBProduct() ? 'lb' : 'each'}}"></a>

    <ng-container *ngIf="(!hideBuyAgainTag && (isProductSubscribed || (displayableElements?.buyItAgain && product?.pastPurchased)))" >
        <span [attr.data-qa]="isProductSubscribed ? 'ar-schdld-subscrbd' : 'bia_bdg'" class="background-color-neutral-20 color-neutral-90 pc__text-xxs body-text-xs text-center rounded px-1 position-absolute pc__badge">{{isProductSubscribed ? 'Subscribed' : 'Buy again'}}</span>    
    </ng-container>
        <span *ngIf="badgeToDisplay?.badgeName" [attr.data-qa]="isProductSubscribed ? 'ar-schdld-subscrbd' : 'bia_bdg'"
            class="d-flex flex-row text-xs{{badgeToDisplay.isBoldText? '-b' : ''}} pds-tag pds-tag-sizes--medium pds-tag-primary-colors--{{badgeToDisplay?.color || 'neutral'}} position-absolute" style="top: 0;">
            <span *ngIf="!!badgeToDisplay?.icon" class="mr-1 {{ 'pds-svg-' + badgeToDisplay?.icon }}" role="img" aria-hidden="true"></span>
            {{badgeToDisplay?.badgeName}}
        </span>
    
    <div class="pc__tc">
        <ng-container  *ngIf="displayableElements?.image">
            <ng-container *ngIf="calledBy === 'buyItAgainQsc'">
                <div class="pc__tc__checkbox checkbox">
                    <label class="checkbox__group" [for]="'pg'+product.id+'-chk'">
                        <input #checkboxInput class="checkbox__input" type="checkbox"
                            [attr.aria-checked]="isCheckboxChecked" id="pg{{product.id}}-chk" (keydown.enter)="onCheckboxClick($event)" (click)="onCheckboxClick($event)">
                        <span class="checkbox__checkmark" [ngClass]="isCheckboxChecked === true ? 'pc__tc__checkbox__checkmark--checked' : 'pc__tc__checkbox__checkmark'"><span
                                class="svg-checkmark"></span></span>
                        <ng-container *ngIf="isCheckboxChecked === true">
                            <span [id]="'pg'+product.id+'-chk-label'" class="sr-only"> Unselect this checkbox to remove {{product.name}} from your quick start cart.</span>
                        </ng-container>

                        <ng-container *ngIf="isCheckboxChecked === false">
                            <span [id]="'pg'+product.id+'-chk-label'" class="sr-only"> Select this checkbox to add {{product.name}} to your quick start cart.</span>
                        </ng-container>
                    </label>
                </div>
            </ng-container>
            <div class="pc__tc__imgc p-1 d-flex justify-content-center" [ngClass]="{'pc__tc__imgc--unselected' : calledBy === 'buyItAgainQsc' && isCheckboxChecked === false}">
                <div id="{{'pg' + product.id + 'Img'}}" attr.data-bpn="{{ product.id }}">
                    <picture class="{{bgImgOpaque}}">
                        <source media="(max-width: {{sm}})" [attr.data-srcset]="getImageUrl(product.id,'mobile')">
                        <source media="(max-width: {{md}})" [attr.data-srcset]="getImageUrl(product.id,'tablet')">
                        <ng-container *ngIf="configObj?.appName === 'cart' || configObj?.appName === 'dnf' || configObj?.programType === 'dnf'; else noSrc">
                            <img class="ab-lazy pc__tc__imgc__img w-100 h-100" [attr.data-src]="getImageUrl(product.id,'desktop')"
                                [src]="getImageUrl(product.id,'desktop')" alt="{{ (product?.fullName?.length) ? product.fullName : product.name }}" data-qa="prd-itm-img" />
                        </ng-container>
                        <ng-template #noSrc>
                            <img class="ab-lazy pc__tc__imgc__img w-100 h-100" [attr.data-src]="getImageUrl(product.id,'desktop')"
                                alt="{{ (product?.fullName?.length) ? product.fullName : product.name }}" data-qa="prd-itm-img" />
                        </ng-template>
                    </picture>
                </div>
            </div>
        </ng-container>

        <div class="d-flex align-items-end justify-content-end position-relative w-100 pc__tc__cta-container" [ngClass]="{'pc__tc__cta-container--unselected' : calledBy === 'buyItAgainQsc' && isCheckboxChecked === false}">
            <!-- Quantity Stepper-->
            <ng-container *ngIf="displayableElements?.addToCart && itemAvailable && isItemEligibleToAdd && isSlotWithInDelihours">
                    <quantity-stepper-al-v2 id="pg{{product.id}}-qty"
                    [product]="product" 
                    [calledBy]="calledBy"
                    [configObj]="configObj"
                    class="w-100 d-flex justify-content-end"></quantity-stepper-al-v2>
            </ng-container>
        </div>
    </div>

    <div class="pc__bc" [ngClass]="{'pc__bc--unselected' : calledBy === 'buyItAgainQsc' && isCheckboxChecked === false}">
        <div class="d-flex flex-column align-items-start align-self-stretch pt-1 pc__bc__gap">
            <div class="d-flex flex-column align-self-stretch">
                <div class="d-flex body-text-xs pc__text-xxs color-neutral-80 pc__label-container">
                    <ng-container *ngIf="product?.displayEstimateText === 'approx' ">
                        <span aria-hidden="false" data-qa="pr-itm-aprx">
                            approx.
                        </span>
                    </ng-container>
                    <ng-container *ngIf="displayableElements?.sponsoredLabel && product?.featured">
                        <span class="ml-auto" aria-hidden="false" data-qa="prd-itm-spnsrd">Sponsored</span>
                    </ng-container>

                </div>

                <ng-container>
                    <!-- Product Price -->
                    <div class="product-comp-v1__price d-flex align-items-baseline flex-wrap">
                        <span *ngIf="product?.priceIndicator" class="text-l-b font-italic pds-tag-low-price--redwood60 product-comp-v1__price__badge" aria-hidden="true">{{product?.priceIndicator}}</span>
                        <span id="{{'pg' + product.id + 'price'}}" data-qa="prd-itm-prc" class="product-comp-v1__price__text " [ngClass]="{'product-comp-v1__price__saleprice sunshine50 rounded' : product.showStrikeThrough && product?.priceHighlight !== false }">
                            <span class="sr-only">{{ product?.priceIndicator || '' }} Your Price {{ validPrice | currency: 'USD' }}  {{isLBProduct() ? 'lb' : 'each'}}</span>
                            <span class="color-neutral-90" aria-hidden="true"> {{ validPrice | currency: 'USD' }}</span>
                            
                            <span *ngIf="(product.displayUnitQuantityText || isLBProduct()) && product.averageWeight === 1" aria-hidden="true" data-qa="qty-txt"> /
                                {{ isLBProduct() ? (product.unitQuantity | lowercase) : product.displayUnitQuantityText}}</span>
                            <span *ngIf="(product.displayUnitQuantityText || isLBProduct()) && product.averageWeight < 1 && product.averageWeight > 0" aria-hidden="true" data-qa="qty-txt"> /
                                {{ product.averageWeightStr }}
                                {{ isLBProduct() ? (product.unitQuantity | lowercase) : product.displayUnitQuantityText}}</span>

                        </span>
                        <del class="body-text-xxs color-neutral-80" *ngIf="product.showStrikeThrough" data-qa="prd-itm-prc-del">
                            <span class="sr-only">Original Price  {{product.basePrice | currency: 'USD' }}</span>
                            <span aria-hidden="true"> {{product.basePrice | currency: 'USD' }}</span>
                        </del>
                        <!-- Displaying product.basePrice and product.basePrice based on showStrikeThrough-->
                        <span class="body-text-xxs color-neutral-80" id="{{'pg' + product.id + 'unitPer'}}" data-qa="prd-itm-pprc-qty" *ngIf="!isLBProduct()" aria-hidden="true">
                            <span class="sr-only" >price per {{ product.unitQuantity | titlecase}} {{ (product.showStrikeThrough ? product.pricePer : product.basePricePer) | currency: 'USD' }}</span>
                            <span aria-hidden="true">({{ (product.showStrikeThrough ? product.pricePer : product.basePricePer) | currency: 'USD' }} / {{ product.unitQuantity | titlecase}})</span>
                        </span>
                    </div>
                </ng-container>
            </div>

            <!-- Schedule and Save  -->
            <ng-container *ngIf="(!isCustomizableProduct) && displayableElements?.scheduleNSave &&  (!unAttendDeliveryFlag || product.restrictedValue === 0)">
                <auto-replenishment-al-v1 *ngIf="showArSubscription()" 
                    [product]="product"
                    [offers]="offers"
                    [productDetailPath]="productDetailPath" 
                    (setDetailProduct)="setPfmDetailProduct()"
                    [calledBy]="'product-grid-item'"
                    [isPcRedesignDisabled]="false">
                </auto-replenishment-al-v1>
            </ng-container>   
            
            <!-- Product Title -->
            <div [ngClass]="{'pc__tooltip ' : product?.fullName?.length > 60}" class="position-relative">

                <a *ngIf="configObj?.programType !== '1P_SNS' && configObj?.appName !== '1P_OA'" id="{{'pg' + product.id}}" attr.aria-label="{{ (product?.fullName?.length) ? product.fullName : product.name }}" attr.data-bpn="{{ product.id }}" class="title-xxs color-neutral-90 product-fname" data-qa="prd-itm-pttl" (click)=" sendAdIdClickEvent(); onProductClicked(); setPfmDetailProduct()" [attr.href]="productDetailPath" tabindex="-1">
                    {{ product.name }} 
                </a>
                <span *ngIf="configObj?.programType === '1P_SNS' || configObj?.appName === '1P_OA'" id="{{'pg' + product.id}}" attr.data-bpn="{{ product.id }}" class="title-xxs color-neutral-90 product-fname" data-qa="prd-itm-pttl">
                    <span class="sr-only">{{ (product?.fullName?.length) ? product.fullName : product.name }}</span>
                    <span aria-hidden="true">{{ product.name }}</span>
                </span>
                <div *ngIf="product?.fullName?.length > 60" class="pc__tooltip__title">
                    <div class="pc__tooltip__title__arrow-light"></div>
                    <div class="title-xxs color-neutral-90">{{product.fullName}}</div>
                </div>
            </div> 
            <!-- Snap & mto text-->

            <ng-container *ngIf="pcTags.length > 0">
                <div class="w-100">
                    <span *ngFor="let tag of pcTags; let i = index">
                        <span *ngIf="tag.srOnlyText" class="sr-only">{{ tag.srOnlyText }}</span>
                        <span class="pc__tags" [attr.data-qa]="tag.qaAttribute"
                            [attr.aria-hidden]="tag.srOnlyText ? 'true' : 'false'">
                            {{ tag.displayableText }}
                        </span>
                        <span class="pc__tags-divider" *ngIf="pcTags.length > i + 1" aria-hidden="true">
                            |
                        </span>
                    </span>
                </div>
            </ng-container>

            <!-- Product Rating -->
            <ng-container *ngIf="displayableElements?.starRating">
                <div class="rating-stars d-flex align-items-center" *ngIf="showPCReview(product)">
                    <span *ngFor="let review of ratingStars; let i = index" [ngClass]="'svg-star-icon-' + review + '-filled'" class="mr-0" aria-hidden="true"></span>
                    <span class="sr-only">Rated {{product?.productReview?.avgRating}} out of 5, {{product?.productReview?.reviewCount}} reviews</span>
                    <span aria-hidden="true" class="body-text-xxs color-neutral-80">{{product?.productReview?.reviewCount}}</span>
                </div>
            </ng-container>

        
            <!-- Product Coupon "-->
            <ng-container *ngIf="displayableElements?.coupons && itemAvailable">
                <ng-container *ngIf="productCouponVisible">
                    <product-coupon-al-v2
                        [product]="product"
                        [productOffers]="productOffers"
                        [configObj]="configObj" 
                        class="position-relative">
                    </product-coupon-al-v2>
                </ng-container>
            </ng-container>

            <!-- Pre order start date -->
            <ng-container *ngIf="product?.isPreOrderItem && (!configObj?.programType || configObj?.programType === 'abs' || configObj?.programType === '1P_B2B')">
                <span class="sr-only"> Available starting {{product?.itemEffectiveStartDate | date:'EEEE, MMMM d'}}</span>
                <div aria-hidden="true" class="text-s pt-1">Avail starting <span class="text-s-b--info">{{product?.itemEffectiveStartDate | date:'EEE, MMM d'}}</span></div>
            </ng-container>
        </div>    
        <!-- Displaying days as static upto now-->

        <ng-container *ngIf="displayableElements?.sellerTag && product.isMarketplaceItem === 'Y' && product.sellerId && product.sellerName">
            <div class="title-xxxs pt-2">
                <span>Sold & shipped by</span>
                <div class="links m-0">
                    <a class="links__action link-xs position-relative"
                    [attr.href]="sellerLandingPath">{{product.sellerName}}</a>
                </div>
            </div>
        </ng-container>     
        <ng-container *ngIf="!itemAvailable || (itemAvailable && !isItemEligibleToAdd) || (itemAvailable && !isSlotWithInDelihours) ">
            <div class="pt-2">
                <ng-container *ngTemplateOutlet="product?.isPreOrderItem ? similarProducts : mtoTemplate"></ng-container>

                <!-- MTO Template -->
                <ng-template #mtoTemplate>
                    <span class="title-xxxs color-neutral-80" 
                        *ngIf="displayableElements?.mto && itemAvailable && (!isItemEligibleToAdd || !isSlotWithInDelihours)">
                        {{ reservedTimeIntent | titlecase }} unavailable
                        {{ !isSlotWithInDelihours ? '(Deli open ' + digitalDisplayTimeLabel + ')' + (!isItemEligibleToAdd ? '; ' : '') : '' }}
                        {{ !isItemEligibleToAdd ? 'Requires ' + product?.mtoDisplyableTime : '' }}
                    </span>
                    <span aria-hidden="false" *ngIf="!itemAvailable" class="title-xxxs color-neutral-80" data-qa = "prd-itm-oos">{{product['itemNotAvailableTxt']}}</span>
                    <ng-container *ngTemplateOutlet="similarProducts"> </ng-container>
                </ng-template>

                <!-- Similar Products -->
                <ng-template #similarProducts >
                    <ng-container *ngIf="configObj?.programType !== '1P_SNS' && configObj?.appName !== '1P_OA'">
                        <a class="links__action link-xs position-relative similar-products" data-qa = "prd-itm-vw-smlr-itms"  attr.aria-label="Similar products {{product.name}}" (click)="viewSimilarClick()">Similar products</a>
                    </ng-container>
                </ng-template>

            </div>
        </ng-container>   
    </div>
</div>

